import type { StarBridgeState } from '../NumberKingdomState.js';

export interface PlaceValueDigits {
  hundreds: number;
  tens: number;
  ones: number;
}

export interface CrystalNumberBuilderConfig {
  id: string;
  skillId: string;
  target: number;
  completionBridgeState: StarBridgeState;
}

export function decomposePlaceValue(target: number): PlaceValueDigits {
  if (!Number.isInteger(target) || target < 0 || target > 999) {
    throw new RangeError(`Crystal Number Builder target must be an integer from 0 to 999; received ${target}.`);
  }

  return {
    hundreds: Math.floor(target / 100),
    tens: Math.floor((target % 100) / 10),
    ones: target % 10,
  };
}

export const STAR_BRIDGE_PLACE_VALUE_1: CrystalNumberBuilderConfig = {
  id: 'star-bridge-place-value-1',
  skillId: 'math-place-value-build',
  target: 243,
  completionBridgeState: 'repair-1',
};
